export const environment = {
  production: true,
  localStore: {
    token: 'thomson_reuters_portal.token',
    user: 'thomson_reuters_portal.user',
    lang: 'thomson_reuters_portal.lang'
  }
};
